import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=23a3bb5b&scoped=true&lang=pug&"
import script from "./AppToolbar.vue?vue&type=script&lang=ts&"
export * from "./AppToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./AppToolbar.vue?vue&type=style&index=0&id=23a3bb5b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a3bb5b",
  null
  
)

export default component.exports